module.exports = __webpack_public_path__ + "static/media/close.eb2a6fa8.svg";